import { useEffect } from "react";
import { useIntercom } from "react-use-intercom";

import { useBasicData } from "@/hooks";

export const IntercomProvider = () => {
  const { update } = useIntercom();
  const { user, workspace } = useBasicData();

  useEffect(() => {
    if (user) {
      const customAttributes: Record<string, any> = {};
      if (workspace) {
        customAttributes.last_workspace_id = workspace.id;
        customAttributes.last_workspace_name = workspace.name;
        customAttributes.last_workspace_tier = workspace.planTier;
      }

      // TODO: Review the GetBasicData query, `!` may be missing because it does not make sense that user.email/id is nullable
      update({
        email: user.email ?? undefined,
        name: user.name ?? undefined,
        userId: user.id,
        userHash: user.intercomHash ?? undefined,
        avatar: {
          type: "avatar",
          imageUrl: user.profilePicture ?? undefined,
        },
        customAttributes,
        customLauncherSelector: "#intercom-button",
        hideDefaultLauncher: true,
      });
    }
  }, [user, workspace, update]);

  return null;
};
